import React, { useState, createContext, ReactNode, useContext } from "react";
import { ApiResponseType, IUserProfile } from "./ContextType";
import axiosInstance from "../api";

type IContext = {
  user: IUserProfile;
  setUser: (data: IUserProfile) => void;
  getUserProfile: () => void;
  isProfileLoading: boolean;
  introspectToken: () => void;
  clearUser:()=>void;
  
};

const UserContext = createContext<IContext | undefined>(undefined);

export const useDefaultContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useTheme must be used within a CustomToastProvider");
  }
  return context;
};

type IContextProviderProps = {
  children: ReactNode;
};

export const UserContextProvider: React.FC<IContextProviderProps> = ({
  children,
}) => {
  const [isProfileLoading, setIsProfileLoading] = useState<boolean>(true);
  const [user, setUser] = useState<IUserProfile>({
    _id: "",
    user_name: "",
    first_name: "",
    last_name: "",
    email: "",
    gender: "",
    is_email_verified:false,
  is_mobile_verified:false,
    address: {
      address: "",
      city: "",
      country: "",
      state: "",
      zipcode: "",
    },
    dob: "",
    country_code: "",
    mobile_number: "",
    profile_assets: {
      avatar_url: "",
      thumbnail_url: "",
    },
    is_kyc_completed:'',
    kycstatus:''
  });

  const getUserProfile = async (): Promise<ApiResponseType<IUserProfile>> => {
    try {
      setIsProfileLoading(true);
      const response = await axiosInstance.post("/login/profile-details");
      setUser(response.data);
      return {
        success: true,
        data: response.data,
        message: response.data.message,
      };
    } catch (e: any) {
      setIsProfileLoading(false);
      return {
        success: false,
        message: e.response?.data?.message,
      };
    } finally {
      setIsProfileLoading(false);
    }
  };

  const introspectToken = async (): Promise<any> => {
    try {
      setIsProfileLoading(true);

      const response = await axiosInstance.get("/login/token/introspect", {
        headers: {
          "x-client-secret": process.env.REACT_APP_ROLE_API_KEY,
        },
      });
      if (response?.data?.roles[0] === "KALP-STUDIO-SUPER-ADMIN" ||response?.data?.roles[0] === "KS_SCHOLARSHIP"|| response?.data?.roles[0] === "INFLUENCER"|| response?.data?.roles[0] === "EXECUTIVE" ) {
    

        setUser((prev) => {
          return { ...prev, isSuperAdmin: true,role:response?.data?.roles[0] };
        });
      }else{
        setUser((prev) => {
          return { ...prev,role:response?.data?.roles[0] };
        });
      }
    

      return {
        success: true,
        data: response?.data,
        message: response?.data?.message,
      };
    } catch (e: any) {
 


      console.log(e);
      return {
        success: false,
        data: e?.data,
        message: 'invalid token',
      };
    }finally {
      setIsProfileLoading(false);
    }
  };

  const clearUser=()=>{
    setUser({
      _id: "",
      user_name: "",
      first_name: "",
      last_name: "",
      email: "",
      gender: "",
      is_email_verified:false,
    is_mobile_verified:false,
      address: {
        address: "",
        city: "",
        country: "",
        state: "",
        zipcode: "",
      },
      dob: "",
      country_code: "",
      mobile_number: "",
      profile_assets: {
        avatar_url: "",
        thumbnail_url: "",
      },
      is_kyc_completed:'',
      kycstatus:''
    })
  }

  const contextValue = {
    user: user,
    setUser: setUser,
    getUserProfile,
    isProfileLoading,
    introspectToken,
    clearUser
  };

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};
